import {authorize, Overlay} from "@athena-portal/components";
import {
    FalconNavigatorHeader,
    FalconPaymentRequest,
    ICustomerPortalService,
    InstalmentsInfo,
    NewCardForm,
    PolicyPropertyEnum,
    ProductsEnum,
    Types
} from "@falcon/services";
import * as React from 'react';
import {RouteComponentProps} from "react-router-dom";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {CardForm} from "../../../../../components/payments/CardForm";
import {getAmountToDisplay, getProductByPolicyNumber} from "../../../../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";
import {FailedPaymentMessage} from "../../../../../components/payments/FailedPaymentMessage";

interface IPageParams {
    policyNumber: string;
}

interface IProps extends RouteComponentProps<IPageParams> {
    location: any
}

interface IState {
    newCardForm?: NewCardForm,
    directDebitSupported: boolean
}

@authorize
export class PayOffBalanceNewCardPage extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            directDebitSupported: false
        }
    }
    public componentDidMount(): void {
        const request: FalconPaymentRequest = new FalconPaymentRequest();
        const policyNumber = this.props.match.params.policyNumber;
        request.invoiceType = "PAYOFF";
        request.product = getProductByPolicyNumber(policyNumber);

        this.customerPortalService.getInstalmentsInfoByAgreementNumber(this.props.match.params.policyNumber).subscribe((output: InstalmentsInfo) => {
            const payOffAmount = output.payOffAmount;
            request.amount = payOffAmount;
            window.sessionStorage.setItem("paymentAmount", getAmountToDisplay(payOffAmount).toString());

            this.customerPortalService.newCardPaymentStart(request, policyNumber).subscribe((newCardForm: NewCardForm) => {
                this.setState({
                    newCardForm
                })
            })
        })
        if (policyNumber) {
            if (getProductByPolicyNumber(policyNumber) === ProductsEnum.HOME) {
                this.setState({
                    directDebitSupported: true
                });
            } else {
                this.customerPortalService.getPolicyPropertyByPropertyKey(policyNumber, PolicyPropertyEnum.DIRECT_DEBIT_SUPPORTED)
                    .subscribe(partyProperty => {
                        this.setState({
                            directDebitSupported: partyProperty?.value === "true"
                        });
                    });
            }
        }
    }
    public render(): React.ReactNode {
        if (this.state.newCardForm) {
            const customLockedTitle = {
                html:
                    (
                        <div className="text-group title plugin no-indent-desktop">
                            <h1 className="m-0">
                                <span className='secure-payment-icon'>Add new card</span>
                            </h1>
                        </div>
                    )
            };
            return (
                <>
                    <FalconHeader/>
                    {this.props.location.state?.paymentFailed && <FailedPaymentMessage directDebitSupported={this.state.directDebitSupported} />}
                    <div className="plugin pay-off-balance-new-card-page">
                        <FalconNavigatorHeader
                            back={`/dashboard/monthlyPaymentHistory/${this.props.match.params.policyNumber}`}
                            title={customLockedTitle} />
                        <CardForm newCardForm={this.state.newCardForm}
                                  verifyNewCardFailed={false}
                                  policyNumber={this.props.match.params.policyNumber}
                        />
                    </div>
                    <FalconFooter/>
                </>
            )
        } else {
            return <Overlay show={true}/>
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/payOffBalance/PayOffBalanceNewCardPage.tsx